(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"]) return;
  try {
    
  // Drawers
  class DrawersNav extends HTMLElement {
    constructor() {
      super();
      this.options = this.querySelectorAll('.product-details-drawer');
      this.drawers = document.querySelectorAll('.product-drawer');
      this.addEventListeners();
    }

    addEventListeners() {
      this.options.forEach((option) => {
        option.addEventListener('click', (event) => {
          const currentTarget = event.currentTarget;
          const drawerSelector = currentTarget.getAttribute('data-drawer-selector');

          if (currentTarget.classList.contains('active')) {
            currentTarget.classList.toggle('active');
            this.toggleDrawer(drawerSelector);
          } else {
            this.options.forEach((item) => item.classList.remove('active'));
            currentTarget.classList.add('active');
            this.toggleDrawer(drawerSelector);
          }
        });
      });
    }

    toggleDrawer(selector) {
      this.drawers.forEach((drawer) => {
        if (drawer.getAttribute('data-drawer') === selector) {
          drawer.classList.toggle('active');
        } else {
          drawer.classList.remove('active');
        }
      });
    }
  }
  customElements.define('drawers-nav', DrawersNav);

  // Variant Picker
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      const options = this.querySelectorAll('.product-details-option');
      options.forEach((option) => {
        option.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          const variantId = this.getAttribute('data-variant-id');
          const containerSectionId = this.getAttribute('data-container-section-id');
          const url = new URL(this.href);

          // Get the dynamic info
          fetch(url)
            .then((response) => response.text())
            .then((data) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(data, 'text/html');
              
              const newSection = doc.querySelector(`#shopify-section-${containerSectionId}`);
              const currentSection = document.querySelector(`#shopify-section-${containerSectionId}`);
              
              if (newSection && currentSection) {
                currentSection.innerHTML = newSection.innerHTML;
              }

              // Slider
              const sliderSection = document.querySelector(".product-hero-section");
              if (sliderSection) {
                const sliderSectionId = sliderSection.getAttribute('id');
                if (sliderSectionId) {
                  const newSliderSection = doc.querySelector(`#${sliderSectionId}`);
    
                  if (newSliderSection) {
                    sliderSection.innerHTML = newSliderSection.innerHTML;
                  }
                }
              }

              // Kiwi Sizing
              if (window.ks && window.KiwiSizing) {
                window.ks.loadSizing({
                  productData: window.KiwiSizing.data,
                  options: {
                    el: document.getElementById('KiwiSizingChart'),
                  },
                });
              }

              // Update the URL without reloading the page
              window.history.pushState({}, '', url);
            })
            .catch((error) => console.error('Error fetching variant:', error));
        });
      });
    }
  }
  customElements.define('variant-picker', VariantPicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"]) return;
  try {
    
  class ImageSlider extends HTMLElement {
    constructor() {
      super();

      const slider = this;

      let xScroll = slider.classList.contains('x_mouse_scroll');
      let mouseDown = false;
      let startX, scrollLeft;
      var velX = 0;
      var momentumID;

      const mouseDownHandler = (e) => {
        mouseDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        cancelMomentumTracking();
      };
      const mouseUpHandler = (e) => {
        if (mouseDown === true) {
          const endX = e.pageX - slider.offsetLeft;
          const dragThreshold = 5;
          if (Math.abs(endX - startX) < dragThreshold) {
            handleClick(e);
          } else {
            beginMomentumTracking();
          }
          mouseDown = false;
        }
      };
      const handleClick = (e) => {
        let sliderOverlay = document.querySelector('.product-image-overlay');
        const body = document.body;
        // Check if outside
        if (sliderOverlay !== body.lastElementChild) {
          body.appendChild(sliderOverlay);
        }
        sliderOverlay.classList.add('expanded');
        document.body.classList.add('slider-expanded');
      };
      const mouseLeaveHandler = (e) => {
        if (mouseDown === true) {
          beginMomentumTracking();
          mouseDown = false;
        }
      };
      const mouseMoveHandler = (e) => {
        e.preventDefault();
        if (!mouseDown) {
          const mouseX = e.clientX;
          const sliderRect = slider.getBoundingClientRect();
          const sliderCenterX = sliderRect.left + sliderRect.width / 2;

          if (mouseX < sliderCenterX) {
            slider.classList.remove('right-side');
            slider.classList.add('left-side');
          } else {
            slider.classList.remove('left-side');
            slider.classList.add('right-side');
          }

          return;
        } else {
          slider.classList.remove('right-side');
          slider.classList.remove('left-side');
        }
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; //scroll-fast
        var prevScrollLeft = slider.scrollLeft;
        slider.scrollLeft = scrollLeft - walk;
        velX = slider.scrollLeft - prevScrollLeft;
      };

      function beginMomentumTracking() {
        cancelMomentumTracking();
        momentumID = requestAnimationFrame(momentumLoop);
      }
      function cancelMomentumTracking() {
        cancelAnimationFrame(momentumID);
      }
      function momentumLoop() {
        slider.scrollLeft += velX;
        velX *= 0.95;
        if (Math.abs(velX) > 0.5) {
          momentumID = requestAnimationFrame(momentumLoop);
        }
      }

      slider.addEventListener('mousemove', mouseMoveHandler, false);
      slider.addEventListener('mousedown', mouseDownHandler, false);
      slider.addEventListener('mouseup', mouseUpHandler, false);
      slider.addEventListener('mouseleave', mouseLeaveHandler, false);
      // slider.addEventListener('wheel', mouseWheelHandler);
    }
  }
  customElements.define('image-slider', ImageSlider);

  class ImageOverlay extends HTMLElement {
    constructor() {
      super();
      console.log(this.querySelector('[data-close]'));
      this.querySelector('[data-close]').addEventListener('click', () => {
        this.classList.remove('expanded');
        document.body.classList.remove('slider-expanded');
      });
    }
  }
  customElements.define('image-overlay', ImageOverlay);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stores"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const storeSelectorItems = document.querySelectorAll('.store-selector-item');
    const stores = document.querySelector('.stores');

    storeSelectorItems.forEach((item) => {
      item.addEventListener('click', function () {
        const area = this.getAttribute('data-area');
        const isActive = this.classList.contains('active');

        // Remove 'active' class from all items
        storeSelectorItems.forEach((sibling) => sibling.classList.remove('active'));

        // Toggle 'active' class on the clicked item
        if (!isActive) {
          this.classList.add('active');
          stores.setAttribute('data-store-slug', area);
          updateActiveClass(area);
        } else {
          stores.removeAttribute('data-store-slug');
          updateActiveClass(null);
        }
      });
    });
  });
  function updateActiveClass(newClass) {
    const elements = document.querySelectorAll(`[data-area-group]`);
    elements.forEach((element) => {
      if (element.getAttribute('data-area-group') === newClass) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
      element.classList.remove('selected');
    });
  }

  // Get all elements with class 'stores-selector-sub-group'
  var subGroups = document.querySelectorAll('.stores-selector-sub-group');

  // Add click event listener to each element
  subGroups.forEach(function (subGroup) {
    subGroup.addEventListener('click', function () {
      this.classList.toggle('selected');
    });
  });

  } catch(e) { console.error(e); }
})();
      })();
